"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POIStatus = exports.BlindedCommitmentType = void 0;
var BlindedCommitmentType;
(function (BlindedCommitmentType) {
    BlindedCommitmentType["Shield"] = "Shield";
    BlindedCommitmentType["Transact"] = "Transact";
})(BlindedCommitmentType || (exports.BlindedCommitmentType = BlindedCommitmentType = {}));
var POIStatus;
(function (POIStatus) {
    // POI valdated in event list
    POIStatus["Valid"] = "Valid";
    // Shield indexed, but not allowed or blocked yet
    POIStatus["ShieldPending"] = "ShieldPending";
    // Shield blocked
    POIStatus["ShieldBlocked"] = "ShieldBlocked";
    // Transact proof submitted, but not validated yet
    POIStatus["TransactProofSubmitted"] = "TransactProofSubmitted";
    // No proof
    POIStatus["Missing"] = "Missing";
})(POIStatus || (exports.POIStatus = POIStatus = {}));
